/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT components
 */

import Article from '../Article';
import LoadMoreButton from '../LoadMoreButton';

const ArticleTab = ({ articleData, recordCount, searchTerm, loadMore, loading, currentPage, totalPages }) => {
  return (

    <div className="my-32">
      { recordCount > 0 && (
        <h1>{ recordCount } results for &ldquo;{ searchTerm }&rdquo;</h1>
      ) }

      <ul className="search__list-item list-none pl-0">
        { articleData.map( ( article ) => (
          <Article key={ self.crypto.randomUUID() } articleData={ article } endReached={ !( ( currentPage < totalPages ) ) } />
        ) )}
      </ul>

      { ( currentPage < totalPages ) &&
        <LoadMoreButton makeRequest={ loadMore } loading={ loading } />
      }
    </div>

  );
};

export default ArticleTab;
